export function debounce (func, wait, immediate) {
  let timeout
  return function () {
    const context = this
    const args = arguments
    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

export function slideshow (images, id, time, afterPreload) {
  preloadImages(images)

  function cycleImages () {
    document.styleSheets[0].insertRule('.slideshow { background-repeat: no-repeat; background-size: cover; transition: background, background-image 2s ease; }', 1)

    document.getElementById(id).classList.add('slideshow')

    let index = 0
    const length = images.length - 1

    setInterval((function setImage () {
      document.getElementById(id).style.backgroundImage = 'url("/images/' + images[index] + '.jpg")'
      index++
      if (index > length) {
        index = 0
      }
      return setImage
    }()), time * 1000 || 5000)
  }

  function preloadImages (array) {
    let loadedImages = 0
    if (!preloadImages.list) {
      preloadImages.list = []
    }
    const list = preloadImages.list
    for (let i = 0; i < array.length; i++) {
      const img = new Image()
      img.onload = function () {
        const index = list.indexOf(this)
        if (index !== -1) {
          loadedImages++
          if (loadedImages === list.length) {
            try {
              afterPreload()
            } catch (e) {
              console.warn('Error in Callback after Image Preload: ' + e)
            }
            cycleImages()
          }
        }
      }
      list.push(img)
      img.src = '/images/' + array[i] + '.jpg'
    }
  }
}
